
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SurveyAnswers } from '../../backend/backendapi';

@Component
export default class AnswersTable extends Vue {
  @Prop({ required: true })
  answers!: SurveyAnswers;

  formatResult(res: string): string {
    if (!res) {
      return res;
    } else if (res.startsWith('data:image')
        || res.match(/\/.*\.((png)|(jpe?g)|(webp)|(bmp))$/) //updated pictures (e.g. signatures)
    ) {
      return '<img src="' + res + '" alt="image" width="100%"/>';
    } else if (res.startsWith('data:video')) {
      return '<video src="' + res + '" />';
    }
    return res;
  }
}
